import React from "react";
import ContactForm from "../forms/ContactForm";

const slugify = (value) =>
  String(value)
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");

const ServiceEnquiryForm = ({
  serviceName,
  webFormId,
  heading,
  description,
}) => {
  const resolvedWebFormId =
    webFormId || `lloyd_james_${slugify(serviceName || "service")}_enquiry`;

  return (
    <div>
      {description && (
        <p className="max-w-3xl mb-6 sm:mb-8 text-gray-300 text-sm sm:text-base leading-relaxed">
          {description}
        </p>
      )}
      <ContactForm
        title={heading || "Enquire now"}
        webFormId={resolvedWebFormId}
        serviceName={serviceName}
        includeSubject={false}
        includeMessage
      />
    </div>
  );
};

export default ServiceEnquiryForm;
